import { fork, call } from 'redux-saga/effects'

// Sagas
import watchUploadOperations from './operations'

// Controller
import controller from 'fc-ctrl-fieldborders'

// import { watchOperations } from 'fc-operator-fieldborder'

// Selectors
// import operations$ from '../selectors/operations'

export default function *main (): Generator<*, void, *> {
  yield call(controller.start)
  yield fork(controller.watch)
  yield fork(watchUploadOperations)
  // yield fork(watchOperations, { operations$ })
}
